import { useContext, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthContext from '../store/auth-context';
import { getStudentRegistrationStatus } from '../api/auth-api';
import { registrationPage } from '../store/fixed-routing';
import { debugError } from '../utils/debug';

/** Uczeń bez profilu na bieżącej edycji → uzupełnienie rejestracji (prefill). */
export function useStudentRegistrationGuard(): void {
	const { role, token } = useContext(AuthContext);
	const navigate = useNavigate();
	const checkedRef = useRef(false);

	useEffect(() => {
		if (role !== 'student' || !token || checkedRef.current) {
			return;
		}
		checkedRef.current = true;
		getStudentRegistrationStatus(token)
			.then((status) => {
				if (!status?.hasProfileOnLatest) {
					navigate(`${registrationPage}?resume=student`, {
						replace: true,
						state: { studentPrefill: status?.prefill ?? null },
					});
				}
			})
			.catch((error) => debugError('useStudentRegistrationGuard failed', error));
	}, [role, token, navigate]);
}
